/**
 * FedEx + DHL operating markets — synced with DHC lib/cheep/global-carrier-lanes.ts
 * Used for cross-country import lanes on the CheepSweepz homepage.
 */

export const ORIGIN_MARKETPLACES = {
  US: { sampleUrl: "https://www.amazon.com/", marketplace: "amazon", label: "Amazon US" },
  CA: { sampleUrl: "https://www.amazon.ca/", marketplace: "amazon", label: "Amazon Canada" },
  GB: { sampleUrl: "https://www.amazon.co.uk/", marketplace: "amazon", label: "Amazon UK" },
  DE: { sampleUrl: "https://www.amazon.de/", marketplace: "amazon", label: "Amazon Germany" },
  FR: { sampleUrl: "https://www.amazon.fr/", marketplace: "amazon", label: "Amazon France" },
  JP: { sampleUrl: "https://www.amazon.co.jp/", marketplace: "amazon", label: "Amazon Japan" },
  AU: { sampleUrl: "https://www.amazon.com.au/", marketplace: "amazon", label: "Amazon Australia" },
  CN: { sampleUrl: "https://www.aliexpress.com/", marketplace: "aliexpress", label: "AliExpress" },
  SG: { sampleUrl: "https://www.amazon.sg/", marketplace: "amazon", label: "Amazon Singapore" },
  KR: { sampleUrl: "https://www.coupang.com/", marketplace: "other", label: "Korea marketplaces" },
  IN: { sampleUrl: "https://www.amazon.in/", marketplace: "amazon", label: "Amazon India" },
  MX: { sampleUrl: "https://www.amazon.com.mx/", marketplace: "amazon", label: "Amazon Mexico" },
  BR: { sampleUrl: "https://www.amazon.com.br/", marketplace: "amazon", label: "Amazon Brazil" },
  AE: { sampleUrl: "https://www.amazon.ae/", marketplace: "amazon", label: "Amazon UAE" },
};

/** Supplier pickup countries (FedEx/DHL can collect). */
export const PICKUP_ORIGINS = [
  { code: "JP", name: "Japan", flag: "🇯🇵", region: "apac", popular: true },
  { code: "GB", name: "United Kingdom", flag: "🇬🇧", region: "europe", popular: true },
  { code: "US", name: "United States", flag: "🇺🇸", region: "americas", popular: true },
  { code: "AU", name: "Australia", flag: "🇦🇺", region: "apac", popular: true },
  { code: "CA", name: "Canada", flag: "🇨🇦", region: "americas", popular: true },
  { code: "CN", name: "China", flag: "🇨🇳", region: "apac", popular: true },
  { code: "DE", name: "Germany", flag: "🇩🇪", region: "europe", popular: true },
  { code: "FR", name: "France", flag: "🇫🇷", region: "europe", popular: false },
  { code: "SG", name: "Singapore", flag: "🇸🇬", region: "apac", popular: false },
  { code: "KR", name: "South Korea", flag: "🇰🇷", region: "apac", popular: false },
  { code: "IN", name: "India", flag: "🇮🇳", region: "apac", popular: false },
  { code: "MX", name: "Mexico", flag: "🇲🇽", region: "americas", popular: false },
  { code: "BR", name: "Brazil", flag: "🇧🇷", region: "americas", popular: false },
  { code: "AE", name: "UAE", flag: "🇦🇪", region: "middle_east", popular: false },
];

export function getOriginMarketplace(code) {
  const upper = (code || "US").toUpperCase();
  return ORIGIN_MARKETPLACES[upper] || ORIGIN_MARKETPLACES.US;
}

export function listPopularOrigins() {
  return PICKUP_ORIGINS.filter((o) => o.popular);
}

export function listAllOrigins() {
  return PICKUP_ORIGINS;
}

export function resolveOriginCode(code) {
  const upper = (code || "").trim().toUpperCase();
  return upper === "UK" ? "GB" : upper;
}
